// ITExperienceReducer.js
import { SET_IT_OPTION_SELECTED, RESET_IT_OPTION_SELECTED, SET_IT_SELECTED_OPTION, SET_IT_EXPERIENCE_COMMENTS } from '../actions/itExperienceAction';

const initialState = {
    isOptionSelected: false,
    selectedOption: null,
    comments: "",
};

const ITExperienceReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_IT_OPTION_SELECTED:
            return {
                ...state,
                isOptionSelected: action.payload,
            };
        case RESET_IT_OPTION_SELECTED:
            return {
                ...state,
                isOptionSelected: false,
                selectedOption: null,
                comments: "",
            };
        case SET_IT_SELECTED_OPTION:
            return {
                ...state,
                selectedOption: action.payload,
            };
        case SET_IT_EXPERIENCE_COMMENTS:
            return {
                ...state,
                comments: action.payload,
            };
        default:
            return state;
    }
};

export default ITExperienceReducer;
